import {
  RESET_CUSTOMER,
  SAVE_CUSTOMER,
  DELETE_CUSTOMER,
  SAVE_CHECKOUT_DATA,
} from "../constants/actionTypes";

const doSaveCustomer = payload => ({
  type: SAVE_CUSTOMER,
  payload,
});

const doSaveCheckoutSessionData = payload => ({
  type: SAVE_CHECKOUT_DATA,
  payload,
});

const doResetCustomer = () => ({ type: RESET_CUSTOMER });

const doDeleteCustomer = identifier => ({ type: DELETE_CUSTOMER, identifier });

export { doSaveCustomer, doResetCustomer, doDeleteCustomer, doSaveCheckoutSessionData };
